import { Injectable } from "@angular/core";

import { CerPromptService } from "@ui/cer-ui-prompt.service";
import { UiCommandEvent } from "@ui/cer-ui-types";

import { CustInvoiceClient, CustInvoiceDocumentCommand } from "../api";

import { cmdCustInvoiceDocument, CustInvoiceView } from "./cust-invoice.view";
import { CerFormPaneType } from "@form/cer-form-panes/cer-form-panes.service";
import { CerFormViewSet } from '@form/cer-form-view-set';

import { CerFormView } from "@form/cer-form-view";


@Injectable({ providedIn: 'root' })
export class CustInvoiceService {

  constructor(
    private client: CustInvoiceClient,
    private ui: CerPromptService) {
  }

  public viewSetGet(
        parentView: CerFormView,
        parentKey: object, 
        paneTable: CerFormPaneType = 'main', 
        paneLine: CerFormPaneType = 'bottom', 
        filterOnlyDraft: boolean = null) : CerFormViewSet {
  
    return CustInvoiceView.viewSetGet(
        parentView,
        parentKey,
        paneTable,
        paneLine,
        filterOnlyDraft, 
        (e => this.onCommand(e))
      );
  }
 
  // Commands
  public onCommand(event: UiCommandEvent) {
    switch (event.commandId) {
      case cmdCustInvoiceDocument.id:
        this.documentGet(event);
        break;
    }
  }

  private documentGet(event: UiCommandEvent) {
    var id = event.rowData?.id;
    if (id) {
      var cmd: CustInvoiceDocumentCommand = new CustInvoiceDocumentCommand(
        { id: id, createDraft: false, createPDF: true });
      this.documentGetCommand(cmd, event);
    }
    else {
      this.ui.errorToast('Ingen faktura markeret');
    }
  }

  private documentGetCommand(cmd: CustInvoiceDocumentCommand, event: UiCommandEvent) {
    this.ui.operationBegin('Henter faktura');
    this.client.document(cmd).subscribe({
      next: fileName => {
        this.ui.operationEnd();
        this.ui.openFileToast(fileName);
        //refreshEvent(event);
      },
      error: (error) => {
        this.ui.operationEndError(error);
      }
    });
  }
}
